export default __webpack_public_path__ + "static/media/Choclate.b9f72f7d.png";